export default __webpack_public_path__ + "40b0ac69d906950a2a3ecd8017b8437f.jpg";